import React from "react";

const ShiftAllowanceAssigment = () => {
    return <div>ShiftAllowanceAssigment</div>;
}

export default ShiftAllowanceAssigment;